import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

/** Empty-thread prompt card ids. Hyphens in the catalog id are underscores here. */
export const WORKSPACE_AGENT_PROMPT_CARD_CLICKED_IDS = [
  'prompt_card_export_cdn_links',
  'prompt_card_old_logo',
  'prompt_card_own_skill',
  'prompt_card_rename_convention',
  'prompt_card_resize_board',
  'prompt_card_set_up_custom_fields',
  'prompt_card_skill',
  'prompt_card_tag_new_uploads',
  'prompt_card_tag_product_shots',
  'prompt_card_unused_assets',
  'prompt_card_update_custom_fields',
] as const;

export type WorkspaceAgentPromptCardClickedId = (typeof WORKSPACE_AGENT_PROMPT_CARD_CLICKED_IDS)[number];

const META: Meta = {
  description:
    'The user clicks a prompt card on the workspace agent empty thread. Cards that open a flow or leave the panel still fire this event; a later agent_task_submitted is separate.',
  name: 'agent_prompt_card_clicked',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'Which prompt card was clicked',
      name: 'card_id',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_PROMPT_CARD_CLICKED_IDS],
    },
  ],
};

export default META;
